import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../progress-bar/Loader";
import YesNoModal from "../modal/YesNoModal";
import AddButtonFullText from "../buttons/AddButtonFullText";
import {deleteStake} from "./actions/stakeAction";
import styled from "styled-components";
import StakeModal from "../modal/StakeModal";
import SmallCardProject from "../project/overview/SmallCardProject";
import StakeToggleCard from "./StakeToggleCard";
import CreateProjectModal from "../modal/CreateProjectModal";
import {loadOneAxis} from "../axis/one-axis/oneAxisAction";
import {displayAlert, getImage} from "../../utils/utils";
import accountSVG from "../../images/account.svg";
import UpdateProject from "../project/one-project/update/UpdateProject";
import {DisplayForAmbassador} from "../../permissions/DisplayAccordingToRole";
import {IS_HEAD} from "../../permissions/roleTypes";
import {BlueButton} from "../buttons/ButtonStyles";
import DisplaySwotButton from "../buttons/DisplaySwotButton";
import SwotModal from "../modal/SwotModal";



const StakesSection = ({
                           setOpenStakeView,
                           openStakesView,
                           openEditStakeModal,
                           setOpenEditStakeModal,
                           openCreateStakeModal,
                           setOpenCreateStakeModal,
                       }) => {

    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [selectedStakeId, setSelectedStakeId] = useState(0)
    const [openProjectView, setOpenProjectView] = useState(false)
    const [projectId, setProjectId] = useState(0)
    const [openProjectModal, setOpenProjectModal] = useState(false)
    const [isSend, setIsSend] = useState(false)
    const [isNotSend, setIsNotSend] = useState(false)
    const [isOpenUpdateProject, setIsOpenUpdateProject] = useState(false)
    const [isOpenSwotModal, setIsOpenSwotModal] = useState(false)
    const {isLoading, id: axisId, name, sponsor, stakes} = useSelector(state => state.oneAxis)
    const currentUser = useSelector(state => state.currentUser)
    const dispatch = useDispatch()

    const displayModal = () => {
        if (openDeleteModal) {
            return (
                <YesNoModal
                    name={"l'enjeu (les projets seront déliés de cet enjeu) ? "}
                    setOpenModal={setOpenDeleteModal}
                    handleClickYesAction={deleteRequest}
                    id={selectedStakeId}
                />
            )
        }

        if (openCreateStakeModal) {
            return (
                <StakeModal
                    setOpenModal={setOpenCreateStakeModal}
                    selectedId={selectedStakeId}
                    axisId={axisId}
                />
            )
        }
        if (openEditStakeModal) {
            return (
                <StakeModal
                    setOpenModal={setOpenEditStakeModal}
                    selectedId={selectedStakeId}
                    axisId={axisId}
                />
            )
        }

        if (openProjectModal) {
            return (
                <CreateProjectModal
                    stakeId={selectedStakeId}
                    setOpenModal={setOpenProjectModal}
                />
            )
        }
        if (isOpenUpdateProject) {
            return (
                <UpdateProject
                    setIsOpenUpdateProject={setIsOpenUpdateProject}/>
            )
        }
        if (isOpenSwotModal) {
            return <SwotModal setIsOpenModal={setIsOpenSwotModal} entity={"axis"} name={name}/>
        }
    }

    const displayProjectStake = (stake) => {
        let projects = stake.projects.map(p => p)
        if (IS_HEAD(currentUser.roles) || sponsor?.id === currentUser?.id) {
            projects = stake.projects.map(p => p)
        } else {
            let projectsSelected = []
            projects.forEach((project) => {
                if (project.confidential === true) {
                    if (project.pilot.id === currentUser?.id || project?.coPilot?.id === currentUser?.id) {
                        projectsSelected.push(project)
                    }
                } else {
                    projectsSelected.push(project)
                }
            })
            projects = projectsSelected
        }

        return (
            <WrapperProjects>
                <DisplayForAmbassador
                    hasException={sponsor ? sponsor.id === currentUser.id : false}
                    component={<AddButtonFullText
                        id={projectId}
                        setId={setProjectId}
                        setOpenModal={setOpenProjectModal}
                        setUpdate={setOpenProjectModal}
                        title={"Ajouter un projet"}
                    />}/>

                {projects.length > 0 ?
                    <Grids>
                        {projects.map(p => (
                            <SmallCardProject
                                key={p.id}
                                id={p.id}
                                projectId={p.id}
                                name={p.name}
                                pilot={p.pilot}
                                weather={p.weather}
                                advancement={p.advancement}
                                lastUpdate={p.lastUpdate}
                                endDate={p.endDate}
                                startDate={p.startDate}
                                canBeEdited={true}
                                confidential={p.confidential}
                                isInteractive={false}
                                setIsOpenUpdateProject={setIsOpenUpdateProject}
                            />
                        ))}
                    </Grids>
                    :
                    <h3> Il n'y a pas de projet dans cet enjeu </h3>
                }
            </WrapperProjects>
        )
    }


    const deleteRequest = async (id) => {
        try {
            if (currentUser.status === 200) {
                await dispatch(deleteStake(id))
                setIsSend(true)
                dispatch(loadOneAxis(axisId))
                setOpenDeleteModal(false)
            }
        } catch {
            setIsNotSend(false)
        }
    }

    const displayStakes = () => {
        if (stakes) {
            if (stakes.length === 0) {
                return (
                    <h2> Il n'y a pas d'enjeu dans cet axe </h2>
                )
            } else {
                return (
                    stakes.map(s =>
                        <StakeToggleCard
                            key={s.id}
                            stakeId={s.id}
                            name={s.name}
                            selectedStakeId={selectedStakeId}
                            setOpenDeleteModal={setOpenDeleteModal}
                            openProjectView={openProjectView}
                            setOpenProjectView={setOpenProjectView}
                            setSelectedStakeId={setSelectedStakeId}
                            setOpenEditModal={setOpenEditStakeModal}
                        >
                            {displayProjectStake(s)}
                        </StakeToggleCard>
                    )
                )
            }
        }
    }

    return (
        <Container>
            {isLoading ?
                <Loader/> :
                <Wrapper>
                    {displayAlert(isNotSend, isSend)}
                    {!openProjectView &&
                    <Title>
                        <StyledButton className={"btn-border-black"} onClick={() => setOpenStakeView(!openStakesView)}>
                            <p> Retour aux axes </p>
                        </StyledButton>
                    </Title>
                    }
                    <div className={'flex-col gap-1'}>
                        {sponsor &&
                        <SponsorContainer>
                            <p> Sponsor : </p>
                            <div className={"flex-row ai-center"}>
                                <img src={getImage(sponsor.photo, accountSVG)} alt={"sponsor de l'axe"}/>
                                <p> {sponsor.firstName === "Deleted" ? "Utilisateur supprimé" : sponsor.firstName} {sponsor.lastName === "User" ? "" : sponsor.lastName} </p>
                            </div>
                        </SponsorContainer>
                        }

                        <FirstSection>
                            <DisplaySwotButton
                                name={"Voir le SWOT de l'axe"}
                                setOpenModal={setIsOpenSwotModal}
                            />
                            <BtnContainer>
                                <DisplayForAmbassador
                                    hasException={sponsor !== null && sponsor.id === currentUser.id}
                                    component={
                                        <AddButtonFullText
                                            id={selectedStakeId}
                                            setOpenModal={setOpenCreateStakeModal}
                                            setId={setSelectedStakeId}
                                            setUpdate={setOpenCreateStakeModal}
                                            title={"Ajouter un enjeu"}
                                        />
                                    }
                                />
                            </BtnContainer>
                        </FirstSection>
                    </div>


                    <h2> {stakes.length > 0 ? `Enjeu${stakes.length > 1 ? "x :" : ""}` : ""} </h2>
                    {displayStakes()}
                </Wrapper>
            }
            {displayModal()}
        </Container>
    )
}


const WrapperProjects = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;

  .add-btn {
    width: 15rem;
    align-self: center;
  }

  h3 {
    text-align: center;
    font-weight: 700;
  }
`
const Grids = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  @media (min-width: 1200px) {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    .small-project-card {
      width: 400px;
    }
  }

`

const Container = styled.div`
  @media (min-width: 900px) {
    width: 45%;
    flex-grow: 0.7;
  }
`

const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1em;
  width: 100%;
`

const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: 2em;
  flex-grow: 0.5;

  .add-btn {
    width: 200px;
  }
`
const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  background: var(--color-white);
  padding: 1em;
  overflow-y: auto;

  p {
    width: 100%;
  }

  @media (min-width: 900px) {
    padding: 0 0 0 0;
    position: initial;
    width: 100%;
    margin: 0;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1em;
    background: transparent;
  }
`
const Title = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  gap: 0.5em;
  align-items: center;
  margin-top: 1em;
  margin-bottom: 1em;


  h3 {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 1em;
    margin-top: 1em;
    max-width: 90%;
  }

  @media (min-width: 900px) {
    display: none;
  }
`

const StyledButton = styled(BlueButton)`
  width: 150px;

`

const SponsorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  img {
    margin: 0;
    width: 2.5rem;
    height: 2.5rem;
    object-fit: cover;
    border-radius: 50%;
  }

  p:first-child{
    font-weight: 700;
    width: unset;
  }
  p:not(:first-child){
    padding-left: 0.5em;
    width: unset;
    font-weight: 800;
    font-size: 110%;
  }
`

export default StakesSection;